import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { EnvConfig } from '@shared/definitions';
import { Observable } from 'rxjs';

import { TokenRepository } from '../../auth/infrastructure/token.repository';

@Injectable()
export class ShopAuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly tokenRepository: TokenRepository,
    @Inject(ENV_CONFIG) private readonly config: EnvConfig
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.tokenRepository.getToken();
    /* The shop's own services call the API with an absolute URL, while the shared data libs (orders,
     * cart payment methods, …) use the relative `/api/...` form that `ApiInterceptor` proxies later.
     * Both hit the same backend, so both must carry the shop token — without the relative form a
     * subscription order is posted anonymously and the API rejects it with
     * `subscription_requires_account`. */
    const isShopApiCall = request.url.startsWith(this.config.api) || request.url.startsWith('/api/');
    const isAuthCall = request.url.includes('/v1.0/auth') || request.url.includes('/v1.0/client/auth');

    if (token && isShopApiCall && !isAuthCall) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(request);
  }
}
